import React from 'react'
import TeamMemberCard from '../components/common/teamMemberCard'
import './Execs.css'

import Anna from '../assets/images/HeadShotEdits/Anna Mucea.png'
import Bella from '../assets/images/HeadShotEdits/Bella Zhong.png'
import Brian from '../assets/images/HeadShotEdits/Brain Grigore.png'
import Calvin from '../assets/images/HeadShotEdits/Calvin Zheng.png'
import Danel from '../assets/images/HeadShotEdits/Danel Polyakov.png'
import Dickson from '../assets/images/HeadShotEdits/Dickson Huang.png'
import Emily from '../assets/images/HeadShotEdits/Emily Slosser.png'
import EricL from '../assets/images/HeadShotEdits/Eric Lam.png'
import EricM from '../assets/images/HeadShotEdits/Eric Medina.png'
import Erin from '../assets/images/HeadShotEdits/Erin Atacan.png'
import Jen from '../assets/images/HeadShotEdits/Jen Dong.png'
import Jeremy from '../assets/images/HeadShotEdits/Jeremy Selwin.png'
import Jessica from '../assets/images/HeadShotEdits/Jessica Zhang.png'
import Jonathan from '../assets/images/HeadShotEdits/Jonathan Wilson.png'
import Nadisha from '../assets/images/HeadShotEdits/Nadisha Gautam.png'
import Nicholas from '../assets/images/HeadShotEdits/Nicholas Krsikap.png'
import Nico from '../assets/images/HeadShotEdits/Nico Wilhelm.png'
import Ryan from '../assets/images/HeadShotEdits/Ryan Vuscan.png'
import Sarah from '../assets/images/HeadShotEdits/Sarah Glaspell-Elser.png'
import Steven from '../assets/images/HeadShotEdits/Steven Zhang.png'
import Sudarshan from '../assets/images/HeadShotEdits/Sudarshan Kumar.png'
import Talia from '../assets/images/HeadShotEdits/Talia Ponesse.png'
import Tracy from '../assets/images/HeadShotEdits/Tracy Han.png'
import Wayne from '../assets/images/HeadShotEdits/Wayne Sun.png'


const OurTeam = () => {
    return (
        <div className="exec-page-container">
            <h1 style={{color: "#FEDB01"}}>Co-Chairs</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Bella} name="Bella Zhong" position="Co-Chair" borderColor="y"/>
                <TeamMemberCard pic={Jen} name="Jennifer Dong" position="Co-Chair" borderColor="y"/>
            </div>
            <h1 style={{color: "#143E82"}}>Marketing</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Anna} name="Anna Mucea" position="Marketing Director" borderColor="b"/>
                <TeamMemberCard pic={Jonathan} name="Jonathan Wilson" position="Marketing Officer" borderColor="b"/>
                <TeamMemberCard pic={Brian} name="Brian Grigore" position="Marketing Officer" borderColor="b"/>
                <TeamMemberCard pic={Nadisha} name="Nadisha Gautam" position="Marketing Officer" borderColor="b"/>
            </div>
            <h1 style={{color: "#B21B39"}}>Finance</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Dickson} name="Dixson Huang" position="Finance Director" borderColor="r"/>
            </div>
            <h1 style={{color: "#FEDB01"}}>Partnerships</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Emily} name="Emily Slosser" position="Partnerships Director" borderColor="y"/>
                <TeamMemberCard pic={Jeremy} name="Jeremy Selwin" position="Partnerships Director" borderColor="y"/>
                <TeamMemberCard pic={Wayne} name="Wayne Sun" position="Partnerships Officer" borderColor="y"/>
                <TeamMemberCard pic={EricL} name="Eric Lam" position="Partnerships Officer" borderColor="y"/>
                <TeamMemberCard pic={Talia} name="Talia Ponesse" position="Partnerships Officer" borderColor="y"/>
            </div>
            <h1 style={{color: "#143E82"}}>Technology</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Nicholas} name="Nicholas Krsikap" position="Technology Director" borderColor="b"/>
                <TeamMemberCard pic={Danel} name="Danel Polyakov" position="Technology Officer" borderColor="b"/>
            </div>
            <h1 style={{color: "#B21B39"}}>Operations</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Nico} name="Nico Wilhelm" position="Operations Director" borderColor="r"/>
                <TeamMemberCard pic={Erin} name="Erin Atacan" position="Operations Officer" borderColor="r"/>
                <TeamMemberCard pic={Sarah} name="Sarah Glaspell-Elser" position="Operations Officer" borderColor="r"/>
            </div>
            <h1 style={{color: "#FEDB01"}}>Logistics</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Tracy} name="Tracy Han" position="Logistics Director" borderColor="y"/>
                <TeamMemberCard pic={Sudarshan} name="Sudarshan Kumar" position="Logistics Officer" borderColor="y"/>
                <TeamMemberCard pic={Jessica} name="Jessica Zhang" position="Logistics Officer" borderColor="y"/>
                <TeamMemberCard pic={Steven} name="Steven Zhang" position="Logistics Officer" borderColor="y"/>
            </div>
            <h1 style={{color: "#143E82"}}>First-Year Representatives</h1>
            <div className="exec-prof-container">
                <TeamMemberCard pic={Ryan} name="Ryan Vuscan" position="First-Year Rep." borderColor="b"/>
                <TeamMemberCard pic={Calvin} name="Calvin Zheng" position="First-Year Rep." borderColor="b"/>
                <TeamMemberCard pic={EricM} name="Eric Medina" position="First-Year Rep." borderColor="b"/>
            </div>
        </div>
    )
}

export default OurTeam
